import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { EVALUATION_CONTEXT } from '../features/discover/utils'
import { query } from '../graphql'

export const useRequirementProfileQuery = ({
  careerId,
  language,
  ...options
}) => {
  return useQuery({
    queryKey: QUERY_KEYS.requirementProfile(careerId, language),
    queryFn: async () => {
      const variables = {
        action: 'generateText',
        career_id: careerId,
        language,
        text_generation_context: EVALUATION_CONTEXT.REQUIREMENTPROFILE
      }

      const response = await query({ query: 'helperControl', variables })

      if (!response || response === 'undefined') {
        console.error(
          'REQUIREMENTPROFILE: Invalid response received:',
          response
        )
        throw new Error('Invalid response from helperControl query')
      }

      try {
        const parsed = JSON.parse(response)
        if (!parsed?.body?.generateText?.res) {
          console.error(
            'REQUIREMENTPROFILE: Invalid response structure:',
            parsed
          )
          throw new Error('Invalid response structure from helperControl')
        }
        return parsed.body.generateText.res
      } catch (error) {
        console.error('REQUIREMENTPROFILE: Error parsing response:', error)
        throw new Error('Error parsing response from helperControl')
      }
    },
    enabled: !!careerId,
    ...options
  })
}

// EVALUATION_CONTEXT.REQUIREMENTPROFILE
